import { Pipe, PipeTransform } from '@angular/core';
import { AssetVersionDto } from '@nusign/picflow-backend-types';
import { getAssetVersionDimensions } from '../lib/get-asset-version-dimensions';

@Pipe({
  name: 'assetVersionDimensions',
  standalone: true,
})
export class AssetVersionDimensionsPipe implements PipeTransform {
  transform(
    version: AssetVersionDto,
    backupData?: { width: number; height: number }
  ): { width: number; height: number } {
    return getAssetVersionDimensions(version, backupData);
  }
}
